import Tooltip from "@mui/material/Tooltip";
import { ToolbarButton } from "@mui/x-data-grid";
import React from "react";
import { useDispatch } from "react-redux";
import { Toolbar } from "@mui/x-data-grid";
import { openDialog } from "../../../store/slices/dialog/dialogSlice";
import AddIcon from "@mui/icons-material/Add";

const ManagementToolbar = ({ dialogType }) => {
  const dispatch = useDispatch();
  return (
    <Toolbar>
      <Tooltip title="Add new commodity">
        <ToolbarButton
          aria-describedby="new-panel"
          onClick={() => dispatch(openDialog(dialogType))}
        >
          <AddIcon fontSize="large" />
        </ToolbarButton>
      </Tooltip>
    </Toolbar>
  );
};

export default ManagementToolbar;
